import { Skeleton } from "@progress/kendo-react-indicators";
import { useEffect, useState } from "react";

type SovraSkeletonProps = React.ComponentProps<typeof Skeleton> & {
    durationMs?: number;
};

export const SovraSkeleton: React.FC<SovraSkeletonProps> = ({
    durationMs = 3500,
    animation = { type: "pulse" },
    ...props
}) => {
    const [isAnimating, setIsAnimating] = useState<boolean>(true);

    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            setIsAnimating(false);
        }, durationMs);

        return () => window.clearTimeout(timeoutId);
    }, [durationMs]);

    return <Skeleton {...props} animation={isAnimating ? animation : false} />;
};
